export default __webpack_public_path__ + "static/media/Corpay x Alpha LockUp_Italian - Corporate - Vertical - White.24551e5f.svg";